namespace $.$$ {
	const $bog_ainews_app_sources_custom_rss_feeds = 'my'

	const $bog_ainews_app_source_links = {
		tech: [
			'https://devblogs.microsoft.com/landingpage/',
			'https://blogs.unity3d.com/feed/',
			'https://www.opennet.ru/opennews/opennews_all.rss',
			'https://devblogs.microsoft.com/ifdef-windows/feed/',
			'https://www.zdnet.com/news/rss.xml',
			'https://habr.com/ru/rss/all/all/?fl=ru',
			'https://habr.com/ru/rss/news/',
		],
		shared: ['https://critter.blog/rss', 'https://news.ycombinator.com/rss'],
		russia: [
			'https://daily.afisha.ru/rss/',
			'https://dtf.ru/rss',
			'https://feeds.bbci.co.uk/russian/rss.xml',
			'https://habr.com/ru/rss/news/',
			'https://holod.media/feed',
			'https://istories.media/rss/all.xml',
			'https://meduza.io/rss/all',
			'https://novayagazeta.eu/feed/rss',
			'https://novayagazeta.ru/feed/rss',
			'https://paperpaper.io/feed/',
			'https://rss.dw.com/rdf/rss-ru-all',
			'https://rtvi.com/rss',
			'https://secretmag.ru/exports/rss.xml',
			'https://semnasem.org/rss/default.xml',
			'https://sota.vision/feed/',
			'https://theins.ru/api/rss/ru/default',
			'https://tvrain.tv/export/rss/all.xml',
			'https://vc.ru/rss',
			'https://www.currenttime.tv/api/zgbip_l-vomx-tpe-v_py',
			'https://www.dekoder.org/rss_ru_all.xml',
			'https://www.proekt.media/feed/',
			'https://www.sibreal.org/api/',
			'https://www.sova-center.ru/search/?rss=1&lg=1',
			'https://www.svoboda.org/api/z-pqpil-vomx-tper-ipp',
			'https://zona.media/rss',
		],
		AI: [
			'http://bair.berkeley.edu/blog/feed.xml',
			'http://blog.evjang.com/feeds/posts/default?alt=rss',
			'http://distill.pub/rss.xml',
			'http://magenta.tensorflow.org/feed.xml',
			'http://news.mit.edu/rss/topic/artificial-intelligence2',
			'http://newsletter.ruder.io/?format=rss',
			'https://aidisruptor.ai/feed',
			'https://aiweekly.co/issues.rss',
			'https://bensbites.com/blog/rss.xml',
			'https://blog.ml.cmu.edu/feed/',
			'https://evjang.com/feed',
			'https://garymarcus.substack.com/feed',
			'https://jalammar.github.io/feed.xml',
			'https://lastweekin.ai/feed',
			'https://lilianweng.github.io/index.xml',
			'https://lilianweng.github.io/lil-log/feed.xml',
			'https://machinelearning.apple.com/rss.xml',
			'https://news.google.com/rss/topics/CAAqIAgKIhpDQkFTRFFvSEwyMHZNRzFyZWhJQ1pXNG9BQVAB?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNREZvZVdoZkVnSmxiaWdBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqJAgKIh5DQkFTRUFvSEwyMHZNRzFyZWhJRlpXNHRSMElvQUFQAQ?hl=en-CA&gl=CA&ceid=CA%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqJAgKIh5DQkFTRUFvSEwyMHZNRzFyZWhJRlpXNHRSMElvQUFQAQ?hl=en-US&ceid=CA%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqLAgKIiZDQkFTRmdvTkwyY3ZNVEZpZUdNMk5UWjJOaElGWlc0dFIwSW9BQVAB?hl=en-CA&gl=CA&ceid=CA%3Aen&oc=11',
			'https://news.mit.edu/topic/mitartificial-intelligence2-rss.xml',
			'https://news.mit.edu/topic/mitmachine-learning-rss.xml',
			'https://rss.beehiiv.com/feeds/2R3C6Bt5wj.xml',
			'https://rss.beehiiv.com/feeds/4EFsI5UmM7.xml',
			'https://rss.beehiiv.com/feeds/GcFiF2T4I5.xml',
			'https://rss.beehiiv.com/feeds/gtwKcGOtrm.xml',
			'https://rss.beehiiv.com/feeds/lvG7CGESX1.xml',
			'https://rss.beehiiv.com/feeds/vGKavlVUFO.xml',
			'https://simonwillison.net/atom/everything/',
			'https://syncedreview.com/feed/',
			'https://techcrunch.com/category/artificial-intelligence/feed/',
			'https://techxplore.com/rss-feed/breaking/machine-learning-ai-news/',
			'https://techxplore.com/rss-feed/machine-learning-ai-news/',
			'https://the-decoder.com/feed/',
			'https://theconversation.com/us/topics/machine-learning-8332/articles.atom',
			'https://thegradient.pub/rss/',
			'https://towardsdatascience.com/feed',
			'https://venturebeat.com/category/ai/feed/',
			'https://www.ai-supremacy.com/feed',
			'https://www.amazon.science/index.rss',
			'https://www.exponentialview.co/feed',
			'https://www.interconnects.ai/feed',
			'https://www.latent.space/feed',
			'https://www.louisbouchard.ai/rss/',
			'https://www.nextomoro.com/rss/',
			'https://www.reddit.com/r/Anthropic/.rss',
			'https://www.reddit.com/r/ChatGPT/.rss',
			'https://www.reddit.com/r/ChatGPTCoding/.rss',
			'https://www.reddit.com/r/DeepSeek/.rss',
			'https://www.reddit.com/r/LocalLLaMA/.rss',
			'https://www.reddit.com/r/MachineLearning/.rss',
			'https://www.reddit.com/r/MachineLearning/top/.rss',
			'https://www.reddit.com/r/OpenAI/.rss',
			'https://www.reddit.com/r/agi/.rss',
			'https://www.reddit.com/r/artificial/.rss',
			'https://www.sciencedaily.com/rss/computers_math/artificial_intelligence.xml',
			'https://www.swyx.io/rss.xml',
			'https://www.theverge.com/rss/ai-artificial-intelligence/index.xml',
			'https://www.tostring.ai/feed',
			'https://www.unite.ai/feed/',
			'https://www.wired.com/feed/rss',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UC5Wz4fFacYuON6IKbhSa7Zw',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCCKx8mAHiFus-XYQLy_WnaA',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCDZfn935vwaahDabsfylfIQ',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCDq7SjbgRKty5TgGafW8Clg',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCEAbqW0HFB_UxZoUDO0kJBw',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCPocEocBKqXv5rzQYWugHMQ',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCZHmQk67mSJgfCCTn7xBfew',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCbfYPyITQ-7l4upoX8nvctg',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCcIXc5mJsHVYTZR1maL5l9w',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UChpleBmo18P08aKCIgti38g',
		],
		Asia: [
			'http://feeds.bbci.co.uk/news/world/asia/rss.xml',
			'https://feeds.npr.org/1125/rss.xml',
			'https://rss.dw.com/rdf/rss-en-asia',
			'https://rss.nytimes.com/services/xml/rss/nyt/AsiaPacific.xml',
			'https://www.economist.com/asia/rss.xml',
			'https://www.euronews.com/rss?level=program&name=asia-news',
			'https://www.ft.com/world/asia-pacific?format=rss',
			'https://www.scmp.com/rss/3/feed',
			'https://www.theguardian.com/world/asia/rss',
		],
		Autos: ['https://www.sfgate.com/rss/feed/car-news-rss-feed-441.php'],
		Bay: [
			'http://www.smdailyjournal.com/search/?f=rss&t=article&c=news/local&l=50&s=start_time&sd=desc',
			'https://48hills.org/feed/',
			'https://abc7news.com/feed/',
			'https://calmatters.org/feed/',
			'https://hoodline.com/news/bay-area/rss/',
			'https://localnewsmatters.org/feed/',
			'https://lookout.co/feed/',
			'https://midpenpost.org/feed/',
			'https://missionlocal.org/feed/',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNRFp3ZG5JU0FtVnVLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://oaklandside.org/feed/',
			'https://pacificsun.com/feed/',
			'https://padailypost.com/feed/',
			'https://sanjosespotlight.com/feed/',
			'https://sf.eater.com/rss/index.xml',
			'https://sfbayca.com/feed/',
			'https://sfbaytimes.com/feed/',
			'https://sfbayview.com/feed/',
			'https://sfist.com/rss/',
			'https://sfnews.us/rss/',
			'https://sfstandard.com/feed/',
			'https://sftimes.com/feed/',
			'https://whatnow.com/san-francisco/feed/',
			'https://www.almanacnews.com/feed/',
			'https://www.cbsnews.com/sanfrancisco/latest/rss/local-news',
			'https://www.eastbaytimes.com/location/california/bay-area/feed/',
			'https://www.kron4.com/feed/',
			'https://www.kron4.com/news/app-feed',
			'https://www.ktvu.com/rss/category/local-news',
			'https://www.marinij.com/local-news/feed/',
			'https://www.mercurynews.com/location/california/bay-area/feed/',
			'https://www.mercurynews.com/location/california/bay-area/peninsula/feed/',
			'https://www.nbcbayarea.com/news/local/feed/',
			'https://www.paloaltoonline.com/feed/',
			'https://www.reddit.com/r/bayarea/.rss',
			'https://www.reddit.com/r/sanfrancisco/.rss',
			'https://www.sfgate.com/bayarea/feed/bay-area-news-429.php',
			'https://www.sfpublicpress.org/category/news/feed/',
			'https://www.siliconvalley.com/feed/',
			'https://www.thesfnews.com/feed',
		],
		Books: [
			'https://feeds.feedburner.com/nybooks',
			'https://www.goodreads.com/blog/list_rss',
			'https://www.nytimes.com/section/books/review/rss.xml',
			'https://www.nytimes.com/svc/collections/v1/publish/',
			'https://www.theguardian.com/books/booksblog/rss',
		],
		Business: [
			'http://feeds.benzinga.com/benzinga',
			'http://feeds.feedburner.com/AtlanticBusinessChannel',
			'http://feeds.feedburner.com/CalculatedRisk',
			'http://feeds.feedburner.com/TheBigPicture',
			'http://feeds2.feedburner.com/businessinsider',
			'http://fortune.com/feed/',
			'http://freakonomics.com//feed/',
			'http://www.economist.com/rss/the_world_this_week_rss.xml',
			'http://www.marketwatch.com/rss/topstories/',
			'http://www.metafilter.com/tags/business/rss',
			'http://www.metafilter.com/tags/economics/rss',
			'http://www.sbnonline.com/feed/',
			'http://www.thenonprofittimes.com/feed/',
			'https://abcnews.go.com/abcnews/moneyheadlines',
			'https://api.axios.com/feed/business',
			'https://economictimes.indiatimes.com/rssfeedsdefault.cms',
			'https://feeds.a.dj.com/rss/RSSMarketsMain.xml',
			'https://feeds.a.dj.com/rss/WSJcomUSBusiness.xml',
			'https://feeds.bbci.co.uk/news/business/rss.xml',
			'https://feeds.bloomberg.com/business/news.rss',
			'https://feeds.bloomberg.com/economics/news.rss',
			'https://feeds.bloomberg.com/markets/news.rss',
			'https://feeds.bloomberg.com/wealth/news.rss',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/economy-and-business',
			'https://feeds.feedburner.com/Mixergy-main-podcast',
			'https://feeds.npr.org/1006/rss.xml',
			'https://feeds.npr.org/1017/rss.xml',
			'https://feeds.washingtonpost.com/rss/business',
			'https://finance.yahoo.com/news/rssindex',
			'https://fortune.com/feed',
			'https://homebusinessmag.com/feed/',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNR1J5Y1hBU0FtVnVLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNREpmTjNRU0FtVnVLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRGx6TVdZU0FtVnVHZ0pWVXlnQVAB?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqKAgKIiJDQkFTRXdvSkwyMHZNR2RtY0hNekVnWmxjeTAwTVRrb0FBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://openrss.org/apnews.com/business',
			'https://openrss.org/www.reuters.com/business/',
			'https://qz.com/rss',
			'https://rss.dw.com/rdf/rss-en-bus',
			'https://rss.nytimes.com/services/xml/rss/nyt/Business.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/Economy.xml',
			'https://seekingalpha.com/feed.xml',
			'https://seekingalpha.com/listing/most-popular-articles.xml',
			'https://seekingalpha.com/market_currents.xml',
			'https://seekingalpha.com/tag/editors-picks.xml',
			'https://soylentnews.org/index.rss',
			'https://theconversation.com/us/business/articles.atom',
			'https://tim.blog/feed/',
			'https://time.com/business/feed',
			'https://www.cbsnews.com/latest/rss/moneywatch',
			'https://www.chicagotribune.com/business/feed/',
			'https://www.cnbc.com/id/100003114/device/rss/rss.html',
			'https://www.economist.com/finance-and-economics/rss.xml',
			'https://www.euronews.com/rss?level=vertical&name=business',
			'https://www.firstpost.com/commonfeeds/v1/mfp/rss/business.xml',
			'https://www.ft.com/companies?format=rss',
			'https://www.ft.com/markets?format=rss',
			'https://www.ft.com/rss/home',
			'https://www.ft.com/rss/home/international',
			'https://www.ft.com/technology?format=rss',
			'https://www.gobankingrates.com/feed/',
			'https://www.investing.com/rss/news.rss',
			'https://www.latimes.com/business/rss2.0.xml',
			'https://www.mckinsey.com/insights/rss.aspx',
			'https://www.pbs.org/newshour/feeds/rss/economy',
			'https://www.reddit.com/r/Economics/.rss',
			'https://www.reddit.com/r/GlobalMarkets/.rss',
			'https://www.reddit.com/r/business/.rss',
			'https://www.reddit.com/r/economy/.rss',
			'https://www.reddit.com/r/finance/.rss',
			'https://www.reddit.com/r/investing/.rss',
			'https://www.rt.com/rss/business/',
			'https://www.scmp.com/rss/92/feed',
			'https://www.seattletimes.com/business/feed/',
			'https://www.sfgate.com/rss/feed/business-and-technology-news-448.php',
			'https://www.spiegel.de/international/business/index.rss',
			'https://www.theguardian.com/uk/business/rss',
			'https://www.theguardian.com/uk/money/rss',
			'https://www.wired.com/feed/category/business/latest/rss',
			'https://www.youtube.com/feeds/videos.xml?user=Bloomberg',
			'https://www.youtube.com/feeds/videos.xml?user=businessinsider',
		],
		'Celebs and Movies': [
			'http://entertainmentweekly.tumblr.com/rss',
			'http://www.tmz.com/rss.xml',
			'https://feeds2.feedburner.com/slashfilm',
			'https://www.avclub.com/rss',
		],
		Culture: [
			'http://feeds.feedburner.com/99pi',
			'http://feeds.kottke.org/main',
			'https://aeon.co/feed.rss',
			'https://feeds.feedburner.com/damninteresting/all',
			'https://feeds.npr.org/1008/rss.xml',
			'https://feeds.npr.org/1045/rss.xml',
			'https://feeds.npr.org/1048/rss.xml',
			'https://quillette.com/tag/art-and-culture/rss/',
			'https://rss.csmonitor.com/feeds/theculture',
			'https://rss.dw.com/rdf/rss-en-cul',
			'https://theconversation.com/us/arts/articles.atom',
			'https://www.atlasobscura.com/feeds/latest',
			'https://www.boston.com/category/culture/feed/',
			'https://www.euronews.com/rss?level=vertical&name=culture',
			'https://www.firstpost.com/commonfeeds/v1/mfp/rss/art-and-culture.xml',
			'https://www.latimes.com/entertainment-arts/rss2.0.xml',
			'https://www.openculture.com/feed',
			'https://www.pbs.org/newshour/feeds/rss/arts',
			'https://www.pbs.org/newshour/feeds/rss/education',
			'https://www.scmp.com/rss/318202/feed',
			'https://www.scmp.com/rss/322296/feed',
			'https://www.sfgate.com/rss/feed/culture-530.php',
			'https://www.wired.com/feed/category/culture/latest/rss',
		],
		Design: [
			'http://airbnb.design/feed/',
			'http://boxesandarrows.com/rss/',
			'http://feeds.feedburner.com/uxmovement',
			'https://feeds.feedburner.com/CssTricks',
			'https://feeds.feedburner.com/JustCreativeDesignBlog',
			'https://feeds.npr.org/1047/rss.xml',
			'https://interaction-design.org/rss/site_news.xml',
			'https://slack.design/feed/',
			'https://usabilitygeek.com/feed/',
			'https://uxdesign.cc/feed',
			'https://uxmatters.com/index.xml',
			'https://uxmovement.com/feed/',
			'https://uxplanet.org/feed',
			'https://uxstudioteam.com/ux-blog/feed/',
			'https://web.dev/feed.xml',
			'https://www.invisionapp.com/inside-design/feed',
			'https://www.nngroup.com/feed/rss/',
			'https://www.smashingmagazine.com/feed',
			'https://www.smashingmagazine.com/feed/',
		],
		Food: [
			'http://feeds.feedburner.com/seriouseatsfeaturesvideos',
			'http://feeds.feedburner.com/smittenkitchen',
			'https://www.101cookbooks.com/feed',
			'https://www.sfgate.com/rss/feed/food-dining-550.php',
			'https://www.skinnytaste.com/feed/',
		],
		'Freedom From Accounts': ['http://beeple.tumblr.com/rss', 'https://vimeo.com/user36872580/videos/rss'],
		Gaming: [
			'http://feeds.arstechnica.com/arstechnica/gaming/',
			'http://feeds.feedburner.com/RockPaperShotgun',
			'http://feeds.feedburner.com/TheAncientGamingNoob',
			'http://feeds.feedburner.com/psblog',
			'http://feeds.ign.com/ign/all',
			'http://feeds.ign.com/ign/games-all',
			'http://indiegamesplus.com/feed',
			'http://itrunsdoom.tumblr.com/rss',
			'http://news.xbox.com/feed',
			'http://rss.slashdot.org/Slashdot/slashdotGames',
			'http://tinycartridge.com/rss',
			'http://toucharcade.com/feed/',
			'http://www.metafilter.com/tags/games/rss',
			'http://www.metafilter.com/tags/gaming/rss',
			'http://www.newgamernation.com/feed/',
			'http://www.nintendolife.com/feeds/latest',
			'http://www.pushsquare.com/feeds/latest',
			'http://www.vg247.com/feed/',
			'https://80.lv/feed',
			'https://arstechnica.com/gaming/feed/',
			'https://dotesports.com/feed',
			'https://esports.gg/api/feed/',
			'https://esportsinsider.com/feed',
			'https://feeds.feedburner.com/Co-optimus',
			'https://feeds.feedburner.com/GeekNative',
			'https://galyonk.in/feed',
			'https://gamerant.com/feed/',
			'https://gameranx.com/feed/',
			'https://games.mxdwn.com/feed/',
			'https://gematsu.com/feed',
			'https://indiegamecloud.com/feed/',
			'https://insider-gaming.com/feed/',
			'https://kotaku.com/rss',
			'https://majornelson.com/feed/',
			'https://mynintendonews.com/feed',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNREZ0ZHpFU0FtVnVLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNREp4YURjNUVnSnlkU2dBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNRFkxYTNKNkVnSmxiaWdBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.xbox.com/en-us/feed/',
			'https://nichegamer.com/feed/',
			'https://nowrongwaytoplay.tumblr.com/rss',
			'https://retrododo.com/feed/',
			'https://store.steampowered.com/feeds/news.xml',
			'https://tagn.wordpress.com/feed/',
			'https://techaeris.com/feed/',
			'https://techiemag.co.uk/category/gaming/feed/',
			'https://toucharcade.com/feed/',
			'https://wccftech.com/feed/',
			'https://www.cgchannel.com/feed/',
			'https://www.destructoid.com/feed/',
			'https://www.esports.net/feed/',
			'https://www.eurogamer.net/?format=rss',
			'https://www.eurogamer.net/feed',
			'https://www.eventhubs.com/news/feed/frontpage/',
			'https://www.gamesindustry.biz/feed',
			'https://www.gamespot.com/feeds/mashup/',
			'https://www.gamesradar.com/feeds.xml',
			'https://www.gamewatcher.com/feeds/rss',
			'https://www.gematsu.com/feed',
			'https://www.giantbomb.com/feeds/mashup',
			'https://www.indieretronews.com/feeds/posts/default',
			'https://www.inoreader.com/stream/user/1004847564/tag/Gaming%20Company%20Feeds',
			'https://www.makeupandbeautyblog.com/feed/',
			'https://www.mmorpg.com/rss',
			'https://www.only-gaming.com/feed/',
			'https://www.operationsports.com/feed/',
			'https://www.pcgamer.com/feeds.xml/',
			'https://www.pcgamesn.com/mainrss.xml',
			'https://www.pcinvasion.com/feed/',
			'https://www.pcworld.com/gaming/news/feed',
			'https://www.penny-arcade.com/feed',
			'https://www.polygon.com/rss/index.xml',
			'https://www.reddit.com/r/Games/.rss',
			'https://www.reddit.com/r/NintendoSwitch/.rss',
			'https://www.reddit.com/r/PS5/.rss',
			'https://www.reddit.com/r/XboxSeriesX/.rss',
			'https://www.reddit.com/r/consoles/.rss',
			'https://www.reddit.com/r/esports/.rss',
			'https://www.reddit.com/r/gamers/.rss',
			'https://www.reddit.com/r/gaming.rss',
			'https://www.reddit.com/r/indiegames/.rss',
			'https://www.reddit.com/r/pcgaming/.rss',
			'https://www.reddit.com/r/playstation/.rss',
			'https://www.reddit.com/r/retrogaming/.rss',
			'https://www.retrogarden.co.uk/feed/',
			'https://www.retronews.com/feed/',
			'https://www.rockpapershotgun.com/feed/',
			'https://www.siliconera.com/feed/',
			'https://www.thegamer.com/feed/',
			'https://www.theguardian.com/games/rss',
			'https://www.timeextension.com/feeds/latest',
			'https://www.tomshardware.com/feeds/tag/pc-gaming',
			'https://www.vg247.com/feed/',
		],
		Guns: [
			'https://homemadeguns.wordpress.com/feed/',
			'https://www.forgottenweapons.com/feed/',
			'https://www.nrablog.com/rss',
			'https://www.thefirearmblog.com/blog/feed/',
		],
		Linux: [
			'http://feeds.feedburner.com/UbuntuhandbookNewsTutorialsHowtosForUbuntuLinux',
			'https://linuxconfig.org/feed',
			'https://linuxhandbook.com/rss/',
			'https://linuxhint.com/feed/',
			'https://tecadmin.net/feed/',
			'https://www.cyberciti.com/feed/',
			'https://www.omgubuntu.co.uk/feed',
			'https://www.rosehosting.com/blog/feed/',
			'https://www.tecmint.com/feed/',
		],
		'Middle East': [
			'https://feeds.npr.org/1009/rss.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/MiddleEast.xml',
			'https://www.lemonde.fr/middle-east/rss_full.xml',
			'https://www.scmp.com/rss/322264/feed',
		],
		Music: [
			'https://3hive.com/feed/',
			'https://daily.bandcamp.com/feed/',
			'https://pitchfork.com/rss/reviews/best/albums/',
			'https://www.nme.com/feed',
			'https://www.stereogum.com/feed/',
		],
		Podcasts: [
			'http://rss.acast.com/themagnusarchives',
			'http://www.uncannyjapan.com/feed/podcast/',
			'https://darknetdiaries.com/podcast.xml',
			'https://rss.acast.com/plumbingthedeathstar',
			'https://www.lorepodcast.com/episodes?format=RSS',
		],
		Science: [
			'http://feeds.bbci.co.uk/news/science_and_environment/rss.xml',
			'http://feeds.feedburner.com/AllDiscovermagazinecomContent',
			'http://feeds.feedburner.com/BodyHorrors',
			'http://rss.cnn.com/rss/edition_space.rss',
			'http://rss.sciam.com/ScientificAmerican-Global',
			'http://rss.sciam.com/ScientificAmerican-Global?format=xml',
			'http://www.futurity.org/feed/',
			'http://www.metafilter.com/tags/science/rss',
			'http://www.nature.com/nature/current_issue/rss',
			'http://www.quantamagazine.org/feed/',
			'http://www.twis.org/feed/',
			'https://api.axios.com/feed/science',
			'https://charmingscience.com/feed/',
			'https://cosmosmagazine.com/feed/',
			'https://eos.org/feed',
			'https://feeds.bbci.co.uk/news/science_and_environment/rss.xml',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/climate',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/health',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/science-tech',
			'https://feeds.feedburner.com/AllDiscovermagazinecomContent',
			'https://feeds.newscientist.com/home',
			'https://feeds.npr.org/1007/rss.xml',
			'https://feeds.npr.org/1025/rss.xml',
			'https://feeds.npr.org/1026/rss.xml',
			'https://feeds.npr.org/1028/rss.xml',
			'https://feeds.science.org/rss/science.xml',
			'https://feeds.simplecast.com/y1LF_sn2',
			'https://flowingdata.com/feed',
			'https://futurism.com/feed',
			'https://gizmodo.com/tag/science/rss',
			'https://grist.org/feed/',
			'https://nautil.us/feed/',
			'https://news.climate.columbia.edu/feed/',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNRE0yWHpJU0FtbDBLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIQgKIhtDQkFTRGdvSUwyMHZNRFZ4YW5RU0FtVnVLQUFQAQ?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNR1F3TmpOMkVnSmxiaWdBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNREU0TXpOM0VnSmxiaWdBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqIggKIhxDQkFTRHdvSkwyMHZNREp3ZVRBNUVnSmxiaWdBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqJQgKIh9DQkFTRVFvSUwyMHZNREUxTkRBU0JXVnVMVWRDS0FBUAE?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp0Y1RjU0FtVnVHZ0pWVXlnQVAB?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news.mit.edu/rss/research',
			'https://news.mit.edu/rss/topic/science-technology-and-society',
			'https://openrss.org/apnews.com/science',
			'https://pa.tedcdn.com/feeds/talks.rss',
			'https://phys.org/rss-feed/',
			'https://phys.org/rss-feed/breaking/',
			'https://podcasts.files.bbci.co.uk/b00snr0w.rss',
			'https://podcasts.files.bbci.co.uk/p002w557.rss',
			'https://quillette.com/tag/science-tech/rss',
			'https://reddit.com/r/science/.rss',
			'https://rss.dw.com/xml/rss_en_environment',
			'https://rss.dw.com/xml/rss_en_science',
			'https://rss.nytimes.com/services/xml/rss/nyt/Climate.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/Science.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/Space.xml',
			'https://sciencealert.com/feed/gn/',
			'https://sciencebasedmedicine.org/feed/',
			'https://scienceblog.com/feed/',
			'https://sciencefeatured.com/feed/',
			'https://scitechdaily.com/feed/',
			'https://sciworthy.com/feed/',
			'https://singularityhub.com/feed/',
			'https://soylentnews.org/index.rss',
			'https://theconversation.com/us/technology/articles.atom',
			'https://thelumberjack.org/category/science/feed/',
			'https://time.com/science/feed/',
			'https://undark.org/feed/',
			'https://what-if.xkcd.com/feed.atom',
			'https://www.advancedsciencenews.com/feed/',
			'https://www.aljazeera.com/xml/rss/all.xml',
			'https://www.anthropocenemagazine.org/feed/',
			'https://www.astro.gla.ac.uk/users/eduard/cesra/?feed=rss2',
			'https://www.economist.com/science-and-technology/rss.xml',
			'https://www.kolabtree.com/blog/feed/',
			'https://www.latimes.com/science/rss2.0.xml',
			'https://www.livescience.com/feeds.xml',
			'https://www.nasa.gov/feed/',
			'https://www.nasa.gov/rss/dyn/lg_image_of_the_day.rss',
			'https://www.nature.com/nature.rss',
			'https://www.nsf.gov/rss/rss_www_news.xml',
			'https://www.pbs.org/newshour/feeds/rss/science',
			'https://www.popsci.com/rss.xml',
			'https://www.psypost.org/feed/',
			'https://www.reddit.com/r/Anthropology/.rss',
			'https://www.reddit.com/r/EarthScience/.rss',
			'https://www.reddit.com/r/Futurism/.rss',
			'https://www.reddit.com/r/Futurology/.rss',
			'https://www.reddit.com/r/Physics/.rss',
			'https://www.reddit.com/r/biology/.rss',
			'https://www.reddit.com/r/chemistry/.rss',
			'https://www.reddit.com/r/climate/.rss',
			'https://www.reddit.com/r/environment/.rss',
			'https://www.reddit.com/r/environmental_science/.rss',
			'https://www.reddit.com/r/hardscience/.rss',
			'https://www.reddit.com/r/science/.rss',
			'https://www.reddit.com/r/space/.rss',
			'https://www.sci.news/feed',
			'https://www.scidev.net/global/rss.xml/?type=header',
			'https://www.science.org/rss/news_current.xml',
			'https://www.sciencealert.com/rss',
			'https://www.sciencedaily.com/rss/all.xml',
			'https://www.sciencenews.org/feed',
			'https://www.scientificamerican.com/platform/syndication/rss/',
			'https://www.scimex.org/rss',
			'https://www.smithsonianmag.com/rss/science-nature/',
			'https://www.snexplores.org/feed',
			'https://www.space.com/feeds/all',
			'https://www.technologynetworks.com/applied-sciences/news/rss',
			'https://www.the-scientist.com/rss/feed-the-scientist.xml',
			'https://www.theguardian.com/environment/climate-crisis/rss',
			'https://www.theguardian.com/science/rss',
			'https://www.thehindu.com/sci-tech/science/feeder/default.rss',
			'https://www.wired.com/feed/category/science/latest/rss',
			'https://www.yahoo.com/news/rss/science',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCqZQJ4600a9wIfMPbYc60OQ',
			'https://www.zmescience.com/feed/',
		],
		Sports: [
			'http://feeds.bbci.co.uk/sport/rss.xml',
			'http://feeds.bbci.co.uk/sport/rss.xml?edition=int#',
			'http://feeds.skynews.com/feeds/rss/sports.xml',
			'http://newsrss.bbc.co.uk/rss/sportonline_world_edition/front_page/rss.xml',
			'http://rss.cnn.com/rss/edition_sport.rss',
			'http://www.espn.com/espn/rss/news',
			'https://api.foxsports.com/v1/rss?partnerKey=zBaFxRyGKCfxBagJG9b8pqLyndmvo7UU',
			'https://e00-marca.uecdn.es/rss/en/index.xml',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/sports',
			'https://feeds.washingtonpost.com/rss/sports',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiQkNCQVNLd29JTDIwdk1EWnVkR29TQW1WdUdnSlZVeUlPQ0FRYUNnb0lMMjB2TURVNWVXb3FCd29GRWdOT1Jrd29BQSoqCAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVABUAE?hl=en-US&gl=US&ceid=US%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiR0NCQVNMd29JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1ETTNhSG9xQ0FvR0VnUkhiMnhtS0FBKi4IACoqCAoiJENCQVNGUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlnQVABUAE?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiRENCQVNMUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1ESjRlaklxQmdvRUVnSkdNU2dBKi4IACoqCAoiJENCQVNGUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlnQVABUAE?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiS0NCQVNNZ29JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1ERnpaMndxQ3dvSkVnZERlV05zYVc1bktBQSouCAAqKggKIiRDQkFTRlFvSUwyMHZNRFp1ZEdvU0JXVnVMVWRDR2dKSFFpZ0FQAVAB?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiS0NCQVNNZ29JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1EbDRjRjhxQ3dvSkVnZERjbWxqYTJWMEtBQSouCAAqKggKIiRDQkFTRlFvSUwyMHZNRFp1ZEdvU0JXVnVMVWRDR2dKSFFpZ0FQAVAB?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiSENCQVNNQW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1EWmljV1FxQ1FvSEVnVlNkV2RpZVNnQSouCAAqKggKIiRDQkFTRlFvSUwyMHZNRFp1ZEdvU0JXVnVMVWRDR2dKSFFpZ0FQAVAB?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiSkNCQVNNUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1EZGljekFxQ2dvSUVnWlVaVzV1YVhNb0FBKi4IACoqCAoiJENCQVNGUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlnQVABUAE?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiSkNCQVNNUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1HcDRlSFFxQ2dvSUVnWlNZV05wYm1jb0FBKi4IACoqCAoiJENCQVNGUW9JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlnQVABUAE?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB/sections/CAQiTENCQVNNd29JTDIwdk1EWnVkR29TQldWdUxVZENHZ0pIUWlJT0NBUWFDZ29JTDIwdk1ESjJlRFFxREFvS0VnaEdiMjkwWW1Gc2JDZ0EqLggAKioICiIkQ0JBU0ZRb0lMMjB2TURadWRHb1NCV1Z1TFVkQ0dnSkhRaWdBUAFQAQ?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB?hl=en-GB&gl=GB&ceid=GB%3Aen',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRFp1ZEdvU0FtVnVHZ0pWVXlnQVAB?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://openrss.org/www.inquirer.com/sports/',
			'https://rss.dw.com/rdf/rss-en-sports',
			'https://rss.nytimes.com/services/xml/rss/nyt/Sports.xml',
			'https://sports.yahoo.com/rss/',
			'https://time.com/sports/feed/',
			'https://www.cbssports.com/rss/headlines/',
			'https://www.chicagotribune.com/sports/feed/',
			'https://www.dawn.com/feeds/sport/',
			'https://www.espn.com/espn/rss/news',
			'https://www.football365.com/rss',
			'https://www.foxsports.com/feedout/syndicatedContent?categoryId=117',
			'https://www.independent.co.uk/sport/rss',
			'https://www.latimes.com/sports/rss2.0.xml',
			'https://www.reddit.com/r/CFB.rss',
			'https://www.reddit.com/r/formula1.rss',
			'https://www.reddit.com/r/indepthsports.rss',
			'https://www.reddit.com/r/mlb.rss',
			'https://www.reddit.com/r/nba.rss',
			'https://www.reddit.com/r/nfl.rss',
			'https://www.reddit.com/r/soccer.rss',
			'https://www.reddit.com/r/sports.rss',
			'https://www.scmp.com/rss/95/feed',
			'https://www.seattletimes.com/sports/feed/',
			'https://www.sfgate.com/rss/feed/top-sports-stories-rss-feed-487.php',
			'https://www.skysports.com/rss/12040',
			'https://www.sportskeeda.com/feed',
			'https://www.teamtalk.com/rss',
			'https://www.theguardian.com/sport/rss',
			'https://www.theguardian.com/uk/sport/rss',
			'https://www.thehindu.com/sport/feeder/default.rss',
			'https://www.triathlonmag.com.au/rss',
			'https://www.westhesportsguy.com/feeds/posts/default',
		],
		Technology: [
			'http://anandtech.com/rss/',
			'http://atomicsupermen.wordpress.com/feed/',
			'http://bloggingthemonkey.blogspot.com/feeds/posts/default',
			'http://boingboing.net/feed',
			'http://feeds.arstechnica.com/arstechnica/index',
			'http://feeds.feedburner.com/AllDiscovermagazinecomContent?format=xml',
			'http://feeds.feedburner.com/IeeeSpectrumFullText',
			'http://feeds.feedburner.com/IntoMobile?format=xml',
			'http://feeds.feedburner.com/KhronosorgNews',
			'http://feeds.feedburner.com/Liliputing?format=xml',
			'http://feeds.feedburner.com/Medgadget',
			'http://feeds.feedburner.com/NanotechwebTechUpdate',
			'http://feeds.feedburner.com/RedmondPie',
			'http://feeds.feedburner.com/Techcrunch',
			'http://feeds.feedburner.com/armdevices?format=xml',
			'http://feeds.feedburner.com/cnx-software/blog?format=xml',
			'http://feeds.feedburner.com/igyaan',
			'http://feeds.feedburner.com/oled-info',
			'http://feeds.feedburner.com/reason/AllArticles',
			'http://feeds.feedburner.com/ubergizmo',
			'http://feeds.feedburner.com/venturebeat/SZYF',
			'http://feeds.mashable.com/Mashable',
			'http://freegamer.blogspot.com/feeds/posts/default',
			'http://gliden64.blogspot.com/feeds/posts/default',
			'http://gpuopen.com/feed/',
			'http://lwn.net/headlines/newrss',
			'http://makezine.com/feed/',
			'http://mobilesemi.blogspot.com/feeds/posts/default',
			'http://rss.cnn.com/rss/cnn_tech.rss',
			'http://rss.nytimes.com/services/xml/rss/nyt/Technology.xml',
			'http://rss.slashdot.org/Slashdot/slashdot',
			'http://rss.slashdot.org/Slashdot/slashdotMain',
			'http://semiaccurate.com/feed/',
			'http://semiengineering.com/feed/',
			'http://sreweekly.com/feed/',
			'http://stratechery.com/feed/',
			'http://thehackernews.com/feeds/posts/default',
			'http://www.androidauthority.com/feed',
			'http://www.androidpolice.com/feed',
			'http://www.cancelledscifi.com/feed/',
			'http://www.computerweekly.com/rss/All-Computer-Weekly-content.xml',
			'http://www.cringely.com/feed/',
			'http://www.digitimes.com/rss/daily.xml',
			'http://www.engadget.com/rss.xml',
			'http://www.extremetech.com/feed',
			'http://www.fark.com/fark.rss',
			'http://www.fudzilla.com/?format=feed',
			'http://www.jeffq.com/blog/feed/',
			'http://www.lakka.tv/articles/feed.xml',
			'http://www.libretro.com/index.php/feed/',
			'http://www.macrumors.com/macrumors.xml',
			'http://www.metafilter.com/tags/apple/rss',
			'http://www.metafilter.com/tags/computers/rss',
			'http://www.metafilter.com/tags/google/rss',
			'http://www.metafilter.com/tags/internet/rss',
			'http://www.metafilter.com/tags/technology/rss',
			'http://www.metafilter.com/tags/web/rss',
			'http://www.mondo2000.com/feed/',
			'http://www.phdcomics.com/gradfeed.php',
			'http://www.phoronix.com/phoronix-rss.php',
			'http://www.pocketables.com/feed',
			'http://www.sammobile.com/feed/',
			'http://www.smbc-comics.com/rss.php',
			'http://www.techcentral.ie/feed/',
			'http://www.techradar.com/rss',
			'http://www.theregister.co.uk/headlines.atom',
			'http://www.theverge.com/rss/full.xml',
			'http://www.tomshardware.com/feeds/rss2/all.xml',
			'http://www.umpcportal.com/feed/',
			'http://www.wired.com/feed/',
			'http://www.xda-developers.com/feed/',
			'http://www.zdnet.com/news/rss.xml',
			'http://xenia.jp/feed.xml',
			'https://512pixels.net/feed/',
			'https://9to5google.com/feed',
			'https://9to5mac.com/feed/',
			'https://abcnews.go.com/abcnews/technologyheadlines',
			'https://androidpctv.com/feed/',
			'https://api.axios.com/feed/technology',
			'https://appleinsider.com/rss/news/',
			'https://atp.fm/rss',
			'https://betanews.com/feed/',
			'https://cloudseclist.com/feed.xml',
			'https://digitechbytes.com/feed/',
			'https://electrek.co/feed/',
			'https://feeds.bbci.co.uk/news/technology/rss.xml',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/science-tech',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/technology',
			'https://feeds.feedblitz.com/newatlas',
			'https://feeds.feedburner.com/ausdroid/feed',
			'https://feeds.feedburner.com/codinghorror',
			'https://feeds.feedburner.com/ndtvnews-top-stories',
			'https://feeds.feedburner.com/thenextweb',
			'https://feeds.macrumors.com/MacRumors-All',
			'https://feeds.npr.org/1019/rss.xml',
			'https://feeds.twit.tv/twit.xml',
			'https://feeds.washingtonpost.com/rss/business/technology',
			'https://flipshope.com/blog/feed',
			'https://futurefive.co.nz/feed',
			'https://futurism.com/feed',
			'https://gigaom.com/feed/?x=1',
			'https://gizmodo.com/feed',
			'https://gizmodo.com/rss',
			'https://hackaday.com/feed/',
			'https://insiderpaper.com/feed/',
			'https://knowtechie.com/feed/',
			'https://krebsonsecurity.com/feed/',
			'https://kubernetes.io/feed.xml',
			'https://latesttechno.in/feed/',
			'https://lobste.rs/rss',
			'https://mobilesyrup.com/feed',
			'https://moviecode.tumblr.com/rss',
			'https://mshibanami.github.io/GitHubTrendingRSS/daily/all.xml',
			'https://news.google.com/rss/topics/CAAqJggKIiBDQkFTRWdvSUwyMHZNRGRqTVhZU0FtVnVHZ0pWVXlnQVAB?hl=en-US&gl=US&ceid=US%3Aen&oc=11',
			'https://news969.com/feed/',
			'https://nocamels.com/feed/',
			'https://openrss.org/www.reuters.com/technology/',
			'https://osmc.tv/rss',
			'https://randomascii.wordpress.com/feed/',
			'https://readwrite.com/feed/',
			'https://restic.net/blog/index.xml',
			'https://retropie.org.uk/feed/',
			'https://rss.nytimes.com/services/xml/rss/nyt/PersonalTech.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/Technology.xml',
			'https://rss.politico.com/technology.xml',
			'https://rthackersnews.blogspot.com/feeds/posts/default?alt=rss',
			'https://soylentnews.org/index.rss',
			'https://spectrum.ieee.org/feeds/feed.rss',
			'https://spider760.blogspot.com/feeds/posts/default?alt=rss',
			'https://stallman.org/rss/rss.xml',
			'https://techcavit.com/feed/',
			'https://techcrunch.com/feed/',
			'https://technode.com/feed/',
			'https://techviral.net/feed/',
			'https://techxplore.com/rss-feed/',
			'https://themarkup.org/feeds/rss.xml',
			'https://thenextweb.com/feed/',
			'https://tildes.net/topics.rss',
			'https://time.com/tech/feed/',
			'https://www.404media.co/rss/',
			'https://www.aclu.org/taxonomy/channel-term/1/feed',
			'https://www.androidauthority.com/feed/',
			'https://www.androidheadlines.com/feed',
			'https://www.antifraudnews.com/feed/',
			'https://www.betechwise.com/feed/',
			'https://www.bleepingcomputer.com/feed/',
			'https://www.blogger.com/feeds/4457929370096894305/posts/default',
			'https://www.chinatechnews.com/feed',
			'https://www.cnet.com/rss/news/',
			'https://www.codeofhonor.com/blog/feed',
			'https://www.cultofmac.com/feed/',
			'https://www.dawn.com/feeds/tech/',
			'https://www.developer-tech.com/feed',
			'https://www.digitaltrends.com/feed/',
			'https://www.droid-life.com/feed',
			'https://www.eff.org/rss/pressrelease',
			'https://www.engadget.com/rss.xml',
			'https://www.eweek.com/feed/',
			'https://www.extremetech.com/feed',
			'https://www.fastcompany.com/latest/rss?truncated=true',
			'https://www.firstpost.com/commonfeeds/v1/mfp/rss/tech.xml',
			'https://www.gadgetsinnepal.com.np/feed/',
			'https://www.geekwire.com/feed',
			'https://www.ghacks.net/feed/',
			'https://www.lastweekinaws.com/feed',
			'https://www.latimes.com/business/technology/rss2.0.xml',
			'https://www.lighthome.in/feed/',
			'https://www.macobserver.com/feed/',
			'https://www.macsparky.com/feed/',
			'https://www.macworld.com/en-us/feed',
			'https://www.macworld.com/index.rss',
			'https://www.mercurynews.com/tag/siliconbeat/feed/',
			'https://www.microled-info.com/rss.xml',
			'https://www.nature.com/nature.rss',
			'https://www.naval-technology.com/feed/',
			'https://www.newskart.com/feed',
			'https://www.nextgov.com/rss/all/',
			'https://www.pcmag.com/feeds/rss/latest',
			'https://www.pcworld.com/index.rss',
			'https://www.platformexecutive.com/feed',
			'https://www.popularmechanics.com/rss/default.xml',
			'https://www.quantamagazine.org/feed',
			'https://www.raspberrypi.org/feed/',
			'https://www.rayarena.com/feed',
			'https://www.reddit.com/r/Apple/.rss',
			'https://www.reddit.com/r/Google/.rss',
			'https://www.reddit.com/r/gadgets/.rss',
			'https://www.reddit.com/r/hardware/.rss',
			'https://www.reddit.com/r/iphone/.rss',
			'https://www.reddit.com/r/technology/.rss',
			'https://www.relay.fm/analogue/feed',
			'https://www.relay.fm/clockwise/feed',
			'https://www.relay.fm/rocket/feed',
			'https://www.researchsnipers.com/feed/',
			'https://www.schneier.com/feed/atom',
			'https://www.scmp.com/rss/36/feed',
			'https://www.securityweek.com/feed/',
			'https://www.servethehome.com/feed/',
			'https://www.siliconrepublic.com/feed',
			'https://www.slashgear.com/feed/',
			'https://www.techdirt.com/techdirt_rss.xml',
			'https://www.techfeeddata.com/feed',
			'https://www.techinasia.com/feed',
			'https://www.techjuice.pk/feed/',
			'https://www.techmeme.com/feed.xml',
			'https://www.technews.city/feeds/posts/default?alt=rss',
			'https://www.technewsworld.com/perl/syndication/rssfull.pl',
			'https://www.technologydrift.com/feed/',
			'https://www.technologyreview.com/feed',
			'https://www.techpout.com/feed/',
			'https://www.techrepublic.com/rssfeeds/articles/?feedType=rssfeeds&sort=latest',
			'https://www.techspot.com/backend.xml',
			'https://www.theblackweb.in/feed/',
			'https://www.theguardian.com/uk/technology/rss',
			'https://www.theverge.com/rss/frontpage',
			'https://www.theverge.com/rss/index.xml',
			'https://www.vox.com/rss/technology/index.xml',
			'https://www.wired.com/feed/rss',
			'https://www.wired.com/feed/tag/ai/latest/rss',
			'https://www.youtube.com/feeds/videos.xml?user=CNETTV',
			'https://www.youtube.com/feeds/videos.xml?user=LinusTechTips',
			'https://www.youtube.com/feeds/videos.xml?user=TheVerge',
			'https://www.youtube.com/feeds/videos.xml?user=marquesbrownlee',
			'https://www.youtube.com/feeds/videos.xml?user=unboxtherapy',
			'https://xkcd.com/rss.xml',
		],
		Travel: [
			'http://rss.cnn.com/rss/cnn_travel.rss',
			'https://rss.nytimes.com/services/xml/rss/nyt/Travel.xml',
			'https://thepointsguy.com/feed/',
			'https://www.adventure-journal.com/feed/',
			'https://www.cntraveler.com/feed/rss',
			'https://www.euronews.com/rss?level=vertical&name=travel',
			'https://www.latimes.com/travel/rss2.0.xml',
			'https://www.lonelyplanet.com/blog/feed/atom/',
			'https://www.sfgate.com/rss/feed/travel-news-and-features-520.php',
			'https://www.theguardian.com/travel/rss',
			'https://www.thehindu.com/life-and-style/travel/feeder/default.rss',
		],
		USA: [
			'http://dailysignal.com//feed/',
			'http://feeds.feedburner.com/Davidthompson',
			'http://feeds.foxnews.com/foxnews/national',
			'http://rss.cnn.com/rss/cnn_allpolitics.rss',
			'http://rss.cnn.com/rss/edition_us.rss',
			'http://rss.slashdot.org/Slashdot/slashdotPolitics',
			'http://www.marketwatch.com/rss/topstories/',
			'http://www.metafilter.com/tags/us/rss',
			'http://www.metafilter.com/tags/uspolitics/rss',
			'http://www.newyorker.com/services/rss/feeds/everything.xml',
			'http://www.slate.com/articles/news_and_politics.fulltext.all.10.rss',
			'http://www.slate.com/articles/news_and_politics/politics.teaser.all.10.rss/',
			'https://abcnews.go.com/abcnews/politicsheadlines',
			'https://abcnews.go.com/abcnews/usheadlines',
			'https://api.axios.com/feed/politics',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/usa',
			'https://feeds.feedburner.com/Popehat',
			'https://feeds.nbcnews.com/msnbc/public/news',
			'https://feeds.npr.org/1014/rss.xml',
			'https://feeds.washingtonpost.com/rss/national',
			'https://feeds.washingtonpost.com/rss/rss_fact-checker',
			'https://feeds.washingtonpost.com/rss/rss_the-fix',
			'https://fivethirtyeight.com/features/feed/',
			'https://justthenews.com/rss.xml',
			'https://nypost.com/politics/feed/',
			'https://nypost.com/us-news/feed/',
			'https://openrss.org/apnews.com/politics',
			'https://openrss.org/apnews.com/us-news',
			'https://openrss.org/www.axios.com',
			'https://openrss.org/www.inquirer.com/politics/',
			'https://pjmedia.com/news-and-politics/feed',
			'https://politicalwire.com/feed/',
			'https://prospect.org/api/rss/content.rss',
			'https://quillette.com/tag/politics/rss',
			'https://reason.com/feed/',
			'https://reason.com/volokh/atom.xml',
			'https://rss.csmonitor.com/feeds/usa',
			'https://rss.nytimes.com/services/xml/rss/nyt/Politics.xml',
			'https://rss.nytimes.com/services/xml/rss/nyt/US.xml',
			'https://status451.com/feed/',
			'https://theconversation.com/us/articles.atom',
			'https://theconversation.com/us/politics/articles.atom',
			'https://thehill.com/homenews/campaign/feed/',
			'https://thehill.com/homenews/feed/',
			'https://thehill.com/homenews/media/feed/',
			'https://thehill.com/lobbying/feed/',
			'https://thehill.com/regulation/feed/',
			'https://theintercept.com/feed/',
			'https://time.com/politics/feed',
			'https://time.com/us/feed',
			'https://www.allsides.com/rss/news',
			'https://www.alternet.org/feeds/feed.rss',
			'https://www.astralcodexten.com/feed',
			'https://www.boston.com/tag/politics/feed/',
			'https://www.cbsnews.com/latest/rss/politics',
			'https://www.chicagotribune.com/news/politics/feed/',
			'https://www.compactmag.com/rss/',
			'https://www.latimes.com/politics/rss2.0.xml',
			'https://www.lemonde.fr/united-states/rss_full.xml',
			'https://www.nationalreview.com/corner/feed/',
			'https://www.nationalreview.com/feed/',
			'https://www.pbs.org/newshour/feeds/rss/politics',
			'https://www.pewresearch.org/feed/',
			'https://www.propublica.org/feeds/propublica/main',
			'https://www.reddit.com/r/AmericanPolitics/.rss',
			'https://www.reddit.com/r/NeutralPolitics/.rss',
			'https://www.reddit.com/r/politics/.rss',
			'https://www.riskhedge.com/rss',
			'https://www.rollingstone.com/politics/feed/',
			'https://www.salon.com/feed/',
			'https://www.scmp.com/rss/322262/feed',
			'https://www.seattletimes.com/nation/feed/',
			'https://www.spiked-online.com/topic/usa/feed/',
			'https://www.theatlantic.com/feed/best-of/',
			'https://www.themarshallproject.org/rss/recent',
			'https://www.thenation.com/feed/?post_type=article',
			'https://www.vox.com/rss/politics/index.xml',
			'https://www.washingtonexaminer.com/section/politics/feed/',
			'https://www.yahoo.com/news/rss/politics',
			'https://www.yahoo.com/news/rss/us',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCDRIjKy6eZOvKtOELtTdeUA',
		],
		'Web Comics': [
			'http://nedroid.com/feed/atom/',
			'http://www.harkavagrant.com/rssfeed.php',
			'http://www.marycagle.com/rss.php',
			'http://www.threepanelsoul.com/rss.php',
			'https://killsixbilliondemons.com/feed/',
			'https://www.foxtrot.com/feed/',
			'https://xkcd.com/atom.xml',
		],
		World: [
			'http://tass.com/rss/v2.xml',
			'https://abcnews.go.com/abcnews/internationalheadlines',
			'https://acleddata.com/feed/',
			'https://aljazeera.com/xml/rss/all.xml',
			'https://allafrica.com/tools/headlines/rdf/latest/headlines.rdf',
			'https://en.mercopress.com/rss/',
			'https://feeds.a.dj.com/rss/RSSOpinion.xml',
			'https://feeds.a.dj.com/rss/RSSWorldNews.xml',
			'https://feeds.bbci.co.uk/news/world/rss.xml',
			'https://feeds.elpais.com/mrss-s/list/ep/site/english.elpais.com/section/international',
			'https://feeds.elpais.com/mrss-s/pages/ep/site/english.elpais.com/portada',
			'https://feeds.feedburner.com/ndtvnews-world-news',
			'https://feeds.npr.org/1004/rss.xml',
			'https://feeds.washingtonpost.com/rss/world',
			'https://foreignpolicy.com/category/world-brief/feed/',
			'https://foreignpolicy.com/feed/',
			'https://jacobin.com/feed/',
			'https://japantoday.com/category/world/feed',
			'https://meduza.io/rss/en/all',
			'https://michaelwest.com.au/feed/',
			'https://novaramedia.com/category/articles/feed/',
			'https://novaramedia.com/feed/',
			'https://openrss.org/apnews.com/world-news',
			'https://openrss.org/www.reuters.com/world/',
			'https://restofworld.org/feed/latest',
			'https://rss.csmonitor.com/feeds/all',
			'https://rss.dw.com/rdf/rss-en-all',
			'https://rss.dw.com/rdf/rss-en-world',
			'https://rss.nytimes.com/services/xml/rss/nyt/World.xml',
			'https://thespectator.com/feed/',
			'https://theweek.com/feeds.xml',
			'https://time.com/world/feed',
			'https://www.abc.net.au/news/feed/45910/rss.xml',
			'https://www.al-monitor.com/rss',
			'https://www.allsides.com/blog',
			'https://www.allsides.com/rss/news',
			'https://www.arabnews.com/taxonomy/term/3/feed',
			'https://www.boston.com/tag/world-news/feed/',
			'https://www.cbsnews.com/latest/rss/world',
			'https://www.compactmag.com/rss/',
			'https://www.dawn.com/feeds/world/',
			'https://www.economist.com/asia/rss.xml',
			'https://www.economist.com/britain/rss.xml',
			'https://www.economist.com/china/rss.xml',
			'https://www.economist.com/europe/rss.xml',
			'https://www.economist.com/international/rss.xml',
			'https://www.economist.com/middle-east-and-africa/rss.xml',
			'https://www.economist.com/the-americas/rss.xml',
			'https://www.euronews.com/rss?level=vertical&name=news',
			'https://www.firstpost.com/commonfeeds/v1/mfp/rss/world.xml',
			'https://www.foreignaffairs.com/rss.xml',
			'https://www.france24.com/en/rss',
			'https://www.ft.com/rss/home/international',
			'https://www.ft.com/world?format=rss',
			'https://www.globalissues.org/news/feed',
			'https://www.lemonde.fr/en/rss/une.xml',
			'https://www.lemonde.fr/opinion/rss_full.xml',
			'https://www.mintpressnews.com/feed/',
			'https://www.newarab.com/rss',
			'https://www.pbs.org/newshour/feeds/rss/world',
			'https://www.pewresearch.org/feed/',
			'https://www.politico.eu/feed/',
			'https://www.reddit.com/r/UpliftingNews/.rss',
			'https://www.reddit.com/r/inthenews/.rss',
			'https://www.reddit.com/r/truenews/.rss',
			'https://www.reddit.com/r/worldnews/.rss',
			'https://www.rferl.org/api/zbqiml-vomx-tpeqkmy',
			'https://www.rfi.fr/en/international/rss',
			'https://www.rt.com/rss/',
			'https://www.rt.com/rss/news/',
			'https://www.scmp.com/rss/5/feed',
			'https://www.scmp.com/rss/91/feed',
			'https://www.semafor.com/rss.xml',
			'https://www.spiegel.de/international/index.rss',
			'https://www.spiegel.de/international/world/index.rss',
			'https://www.spiked-online.com/topic/world/feed/',
			'https://www.straitstimes.com/news/world/rss.xml',
			'https://www.theglobeandmail.com/arc/outboundfeeds/rss/category/world/',
			'https://www.theguardian.com/world/rss',
			'https://www.thehindu.com/news/international/feeder/default.rss',
			'https://www.timesofisrael.com/feed/',
			'https://www.voanews.com/api/',
			'https://www.wsws.org/en/rss.xml',
			'https://www.youtube.com/feeds/videos.xml?channel_id=UCQfwfsi5VrQ8yKZ-UWmAEFg',
		],
	}

	export class $bog_ainews_app_sources extends $.$bog_ainews_app_sources {
		runtime_links() {
			const custom_rss = this.custom_sources($bog_ainews_app_sources_custom_rss_feeds)
			return { ...$bog_ainews_app_source_links, my: custom_rss }
		}

		// tabs fields
		Categories() {
			return Object.keys($bog_ainews_app_source_links).map(category => this.Category_page(category))
		}
		category_title(category: any) {
			return category
		}
		// sources fileds
		suggestions(category: any) {
			const urls = $bog_ainews_app_source_links[category as keyof typeof $bog_ainews_app_source_links]
			// Преобразуем массив URL в объект {url: domain}
			return urls.reduce((acc: any, url: string) => {
				try {
					const domain = new URL(url).hostname.replace('www.', '')
					acc[url] = domain
				} catch {
					acc[url] = url
				}
				return acc
			}, {})
		}

		// @$mol_mem_key
		sources(id: string, next?: any) {
			if (next !== undefined) return $mol_state_local.value(id, next)
			return $mol_state_local.value(id) ?? []
		}

		@$mol_mem_key
		custom_sources(id: string, next?: any) {
			if (next !== undefined) return $mol_state_local.value(id, next)
			return $mol_state_local.value(id) ?? []
		}

		My_rss_feeds() {
			const my_rss = ($mol_state_local.value($bog_ainews_app_sources_custom_rss_feeds) as string[]) ?? []
			return my_rss.map((category: any) => this.My_rss_item(category))
		}

		add_custom_feed_click() {
			const new_url = this.Add_feed_string().value()
			const current_list = this.custom_sources($bog_ainews_app_sources_custom_rss_feeds)

			// skip if alrady added
			if (current_list.includes(new_url)) {
				return
			}

			if (new_url !== null && new_url.trim() !== '') {
				if (new_url.includes('https://') == false && new_url.includes('http://') == false) {
					throw 'Need valid http url!'
				}
			}
			const new_list = [...current_list, new_url]
			this.custom_sources($bog_ainews_app_sources_custom_rss_feeds, new_list)
			$mol_state_local.value($bog_ainews_app_sources_custom_rss_feeds, new_list)
			this.Add_feed_string().value('')
		}

		@$mol_mem_key
		my_rss_title(id: string) {
			return id
		}

		delete_custom_feed_click(id: string) {
			const current_list = this.custom_sources($bog_ainews_app_sources_custom_rss_feeds)
			const new_list = current_list.filter((item: any) => item != id)
			this.custom_sources($bog_ainews_app_sources_custom_rss_feeds, new_list)
			$mol_state_local.value($bog_ainews_app_sources_custom_rss_feeds, new_list)
		}
	}
}
